import { initializeApp } from "firebase/app";

const firebaseConfig = {
  apiKey: "AIzaSyCwp9V5aNBu5E0SsLH1y4qJrLL8QWUKGhM",
  authDomain: "clone-6abe8.firebaseapp.com",
  projectId: "clone-6abe8",
  storageBucket: "clone-6abe8.appspot.com",
  messagingSenderId: "752575321294",
  appId: "1:752575321294:web:061c2c5c5aeed11253ec9f"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);

